/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { useRef, useState } from 'react';
import { Text, Line } from 'react-konva';
import { Vector3 } from 'three';
import * as THREE from 'three';

type KanvasEngravingProps = {
  pattern: {
    inverse_horizontal: boolean;
    inverse_vertical: boolean;
    position: Vector3;
    pieceUUID: string;
    orientation: string;
    uuid: string;
    text: string;
    fontSize: string;
    letterSpacing: string;
    fontFamily: string;
    align: string;
    color: string;
  };
  stageRef: React.MutableRefObject<any>;
  orientation: {
    key: 'x' | 'y' | 'z' | 'free';
    inverse: boolean;
  };
  setPatterns: (patterns: { [key: string]: { [key: string]: any }[] }) => void;
  patterns: {
    [key: string]: { [key: string]: any }[];
  };
  pieceUUID: string;
  setSelectedPattern: (selectedPattern: number | undefined) => void;
  patternIndex: number;
  orbitRef: React.MutableRefObject<any>;
  ratio: number | undefined;
  kanvasSize: { width: number; height: number } | undefined;
};

export const KanvasEngraving = ({
  pattern,
  orientation,
  setPatterns,
  patterns,
  pieceUUID,
  stageRef,
  setSelectedPattern,
  patternIndex,
  orbitRef,
  ratio,
  kanvasSize,
}: KanvasEngravingProps) => {
  const shapeRef = useRef<any>();
  const [showGuides, setShowGuides] = useState<boolean>(false);
  const [guidePosition, setGuidePosition] = useState<{ x: number; y: number }>({ x: 0, y: 0 });

  const changePattern = (position?: Vector3) => {
    const patternsTmp = { ...patterns };
    const currentOrientation = `${orientation.key}${orientation.inverse ? '_inverse' : ''}`;

    patternsTmp[pattern.pieceUUID][currentOrientation].elements = patterns[pattern.pieceUUID][
      currentOrientation
    ].elements.map((element: any) => {
      if (element.uuid === pattern.uuid) {
        return {
          ...element,
          position: position || element.position,
        };
      }
      return element;
    });

    if (stageRef.current && patternsTmp[pieceUUID][currentOrientation]) {
      const canvas = stageRef.current.toCanvas();
      const texture = new THREE.CanvasTexture(canvas);
      patternsTmp[pieceUUID][currentOrientation].texture = texture;

      patternsTmp[pieceUUID][currentOrientation].camera = orbitRef.current.object.clone();
    }

    setPatterns(patternsTmp);
  };

  const handleDragMove = (e: any) => {
    if (!kanvasSize) return;

    const node = shapeRef.current;
    const stage = node.getStage();
    const pointerPosition = stage.getPointerPosition();

    // Calculer la position du centre du canvas
    const centerX = kanvasSize.width / 2;
    const centerY = kanvasSize.height / 2;

    // Vérifier si le texte est proche du centre
    const threshold = 20; // Distance en pixels pour activer le guidage
    const isNearCenterX = Math.abs(pointerPosition.x - centerX) < threshold;
    const isNearCenterY = Math.abs(pointerPosition.y - centerY) < threshold;

    if (isNearCenterX || isNearCenterY) {
      setShowGuides(true);
      setGuidePosition({ x: centerX, y: centerY });

      // Appliquer l'effet d'aimantation
      if (isNearCenterX) {
        node.x(centerX - (node.width() * node.scaleX()) / 2);
      }
      if (isNearCenterY) {
        node.y(centerY - (node.height() * node.scaleY()) / 2);
      }
    } else {
      setShowGuides(false);
    }
  };

  const handleDragEnd = (e: any) => {
    setShowGuides(false);
    const node = shapeRef.current;

    // Vérifier si le texte est proche du centre pour l'aimantation finale
    if (kanvasSize) {
      const centerX = kanvasSize.width / 2;
      const centerY = kanvasSize.height / 2;
      const threshold = 20;

      const finalX = Math.abs(node.x() - centerX) < threshold ? centerX : node.x();
      const finalY = Math.abs(node.y() - centerY) < threshold ? centerY : node.y();

      changePattern(new Vector3(Math.round(finalX), Math.round(finalY), 0));
    }
  };

  const sizeWithRatio = (cm: number) => {
    return cm * (ratio ?? 1) * 1.4;
  };

  const fontSize = sizeWithRatio(
    Number.isNaN(Number.parseInt(pattern.fontSize, 10))
      ? 0.3
      : Number.parseInt(pattern.fontSize, 10),
  );

  const letterSpacing = sizeWithRatio(
    Number.isNaN(Number.parseInt(pattern.letterSpacing, 10))
      ? 0
      : Number.parseInt(pattern.letterSpacing, 10),
  );

  return (
    <>
      {showGuides && (
        <>
          <Line
            points={[guidePosition.x, 0, guidePosition.x, kanvasSize?.height ?? 0]}
            stroke="#ffffff"
            strokeWidth={1}
            dash={[5, 5]}
            shadowColor="#ffffff"
            shadowBlur={10}
            shadowOffset={{ x: 0, y: 0 }}
            shadowOpacity={0.8}
          />
          <Line
            points={[0, guidePosition.y, kanvasSize?.width ?? 0, guidePosition.y]}
            stroke="#ffffff"
            strokeWidth={1}
            dash={[5, 5]}
            shadowColor="#ffffff"
            shadowBlur={10}
            shadowOffset={{ x: 0, y: 0 }}
            shadowOpacity={1}
          />
        </>
      )}
      <Text
        onClick={() => setSelectedPattern(patternIndex)}
        onTap={() => setSelectedPattern(patternIndex)}
        ref={shapeRef}
        x={pattern.position.x}
        y={pattern.position.y}
        fontSize={fontSize}
        letterSpacing={letterSpacing}
        fontFamily={pattern.fontFamily}
        align={pattern.align}
        fill={pattern.color}
        draggable
        onDragMove={handleDragMove}
        onDragEnd={handleDragEnd}
        text={pattern.text}
        onMouseEnter={(e) => {
          const container = e.target?.getStage()?.container();
          if (container) container.style.cursor = 'pointer';
        }}
        onMouseLeave={(e) => {
          const container = e.target?.getStage()?.container();
          if (container) container.style.cursor = 'default';
        }}
      />
    </>
  );
};
